import React, { useRef } from 'react';
import { GlobalSearch as CLGlobalSearch } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { useMediaQuery } from '@fortress-technology-solutions/fortress-component-library/hooks';
import { useGlobalSearch } from './hooks';
import useSelectedProperty from '../../../hooks/useSelectedProperty';
import useUserOrganizationId from '../../../hooks/useUserOrganizationId';

const GlobalSearch = () => {
  const { id: propertyId } = useSelectedProperty() || {};
  const organizationId = useUserOrganizationId();
  const containerRef = useRef(null);

  const {
    searchResults,
    loading,
    currentPathname,
    handleSearch,
    handleSelect,
    recentSearches,
  } = useGlobalSearch(organizationId, propertyId);

  const isMobile = useMediaQuery('only', 'xs');

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        minWidth: isMobile ? 50 : 200,
        width: '30%',
        maxWidth: isMobile ? 30 : 460,
        position: 'relative',
      }}
    >
      <CLGlobalSearch
        key={currentPathname}
        sx={{
          width: '100%',
          '& .MuiAutocomplete-input': {
            paddingTop: '8px !important',
            paddingBottom: '8px !important',
          },
          '& .MuiAutocomplete-popper': {
            position: 'fixed !important',
            width: '400px !important',
            zIndex: 1301,
          },
        }}
        optionsSx={{
          width: 460,
          minWidth: 460,
          maxWidth: 600,
          marginTop: -1,
          zIndex: 1301,
        }}
        disablePortal={false}
        searchResults={searchResults}
        loading={loading}
        onSearch={handleSearch}
        onSelect={handleSelect}
        currentPath={currentPathname}
        recentSearches={recentSearches}
        mobileHeaderBackgroundColor="#5D25B2"
        searchIconColor="#FFF"
      />
    </div>
  );
};

export default GlobalSearch;
